import { useState } from 'react';

export default function useInputRadio({ onChange, checked }) {
  const [animation, setAnimation] = useState(0);

  function handleClick(e) {
    onChange(e, !checked);
    setAnimation(1);
  }
  function animationEnd() {
    setAnimation(0);
  }
  return { animation, handleClick, animationEnd };
}
